<template>
    <Card :title="$t('labels.order_status')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name')" :required="true">
                        <Input v-model="orderStatus.name" type="string" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.type')" :required="true">
                        <AppSelect
                            :model-value="selectedType.value"
                            :selected-value="selectedType.label"
                            :options="typeOptions"
                            @update:model-value="selectedType = $event"
                            option-key="value"
                            option-value="label"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.color')" :required="true">
                        <Input v-model="orderStatus.color" type="color" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.exit_declaration_status')">
                        <Autocomplete 
                            url="/management/exit-declaration-statuses"
                            :model-value="orderStatus.exit_declaration_status?.uuid"
                            :selected-value="orderStatus.exit_declaration_status?.name"
                            :can-be-empty="true"
                            @update:model-value="orderStatus.exit_declaration_status = $event"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="light" @click="remove" class="mr-2">
                <i class="icon-trash mr-2"></i>
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton color="indigo" @click="edit">
                <i class="icon-floppy-disk mr-2"></i>
                <span>{{ $t('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import Autocomplete from "../../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";

import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";
import { OrderStatusTypeEnum } from "../../../../enums/OrderStatusTypeEnum";

export default {
    name: "MainInformationCard",
    components: {
        Card, FormGroup, Input, AppButton, Autocomplete, AppSelect
    },
    emits: ['update:orderStatus'],
    props: {
        orderStatus: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedType: {
                value: this.orderStatus.type,
                label: this.$t(`orderStatus.types.${this.orderStatus.type}`)
            },
            typeOptions: [
                { value: OrderStatusTypeEnum.ACTIVE, label: this.$t('orderStatus.types.active') },
                { value: OrderStatusTypeEnum.DONE, label: this.$t('orderStatus.types.done') },
                { value: OrderStatusTypeEnum.CANCELED, label: this.$t('orderStatus.types.canceled') },
            ]
        }
    },
    methods: {
        edit() {
            httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/statuses/${this.$route.params.orderStatusUuid}`, {
                name: this.orderStatus.name,
                color: this.orderStatus.color,
                exit_declaration_status_uuid: this.orderStatus.exit_declaration_status?.uuid ?? null,
                type: this.selectedType.value
            }).then((response) => {
                new MessageNotificator().success(this.$t("alerts.success"))
                this.$emit('update:orderStatus', response.data.data);
            })
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.order_status')
            }), () => {
                httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/statuses/${this.$route.params.orderStatusUuid}`).then(() => {
                    this.$router.push({ name: 'OrderStatusesPage' })
                })
            })
        }
    },
    
}
</script>